import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router'
import middleware from '../../Api/Middleware';
import { useCookies } from 'react-cookie';
import ToastError from '../../Toasts/ToastError';
import ToastSuccess from '../../Toasts/ToastSuccess';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['reset_token']);
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    const location = useLocation();
 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const resetToken = new URLSearchParams(location.search).get('reset_token');
                if (resetToken) {
                    setCookie('reset_token', resetToken, { path: '/' });
                    clearResetTokenFromUrl();
                }

                if (!resetToken && !cookies.reset_token) {
                    ToastError('Je wachtwoord reset link is verlopen. Vul je e-mailadres opnieuw in voor een nieuwe link.');
                    navigate(`/wachtwoord-vergeten`);
                }
            } catch (err) {
                console.error(err);
                ToastError('Er is een fout opgetreden. Probeer het later opnieuw.');
                navigate('/login');
            }
        };

        fetchData();
    }, [location, setCookie]);

    const clearResetTokenFromUrl = () => {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('reset_token'); // Delete the reset_token query param
        window.history.replaceState(null, '', newUrl); // Update the URL without reloading the page
    };

    const handleSendRequest = async(e) => {
        try {
            e.preventDefault();
            const [updatePasswordRes] = await Promise.all([
                middleware.post('change-forgotten-password', {
                    token: cookies.reset_token,
                    new_password: password,
                    new_password_confirmation: passwordConfirmation,
                })
            ])
            if  (updatePasswordRes.data.ValidationError) {
                ToastError(updatePasswordRes.data.ValidationError)
            }
            if  (updatePasswordRes.data.Success) {
                ToastSuccess(updatePasswordRes.data.Success);
                removeCookie('reset_token');
                navigate('/login');
            }
        } catch (err) {
            console.warn(err)
        }
    } 

  return (
    <div className='backgroundGradient'>
        <div className='position-fixed btn btn-light rounded-circle m-4' onClick={() => navigate('/login')}><FontAwesomeIcon icon={faArrowLeft}/></div>
        <div className='d-flex justify-content-center align-items-center h-100 flex-column'>
            <form onSubmit={handleSendRequest} className=''>
                <div className='h3 text-center text-white mb-5'>Stel je nieuwe wachtwoord in</div>

                <div className="mb-4 input-group-sm">
                    <label htmlFor="new-password" className="visually-hidden">
                        Nieuw wachtwoord
                    </label>
                    <input 
                        type="password" 
                        id="new-password"
                        name="new_password"
                        autoComplete="new-password" 
                        value={password} 
                        onChange={e => setPassword(e.target.value)} 
                        className="form-control inputsUserCredentials" 
                        placeholder="Nieuw wachtwoord"
                        required
                        minLength="8"
                        aria-describedby="password-help"
                    />
                </div>
                
                <div className="mb-4 input-group-sm">
                    <label htmlFor="confirm-password" className="visually-hidden">
                        Wachtwoord bevestigen
                    </label>
                    <input 
                        type="password" 
                        id="confirm-password"
                        name="password_confirmation"
                        autoComplete="new-password" 
                        value={passwordConfirmation} 
                        onChange={e => setPasswordConfirmation(e.target.value)} 
                        className="form-control inputsUserCredentials" 
                        placeholder="Wachtwoord bevestigen"
                        required
                        minLength="8"
                        aria-describedby="password-help"
                    />
                </div>

                {/* Hidden username field to help password managers understand context */}
                <input 
                    type="hidden" 
                    name="username" 
                    autoComplete="username" 
                    value="" 
                />

                <div className='mb-3 input-group-sm'>
                    <button type="submit" className="btn w-100 rounded-pill loginButton">Wachtwoord opslaan</button>
                </div>
            </form>
            <span className='text-danger fw-bolder fs-5 text-wrap'>{error}</span>
        </div>
    </div>
  )
}

export default ResetPassword